import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 12L9 8.48V8.52V15.52L15 12ZM7.62 5.8C7.71087 5.74657 7.81459 5.71891 7.92 5.72C8.25104 5.7582 8.56728 5.87851 8.84 6.07L17.68 11.19C17.7925 11.2573 17.8857 11.3524 17.9505 11.4663C18.0153 11.5802 18.0496 11.709 18.05 11.84V12.12C18.0496 12.2511 18.0153 12.3798 17.9505 12.4937C17.8857 12.6076 17.7925 12.7028 17.68 12.77L8.68 18C8.46186 18.1578 8.20724 18.2575 7.94 18.29C7.82691 18.2913 7.71584 18.2601 7.62 18.2L7.37 18.06C7.25752 17.9928 7.16434 17.8976 7.09951 17.7837C7.03468 17.6698 7.0004 17.5411 7 17.41V6.59C7.0004 6.45895 7.03468 6.33023 7.09951 6.21634C7.16434 6.10244 7.25752 6.00725 7.37 5.94L7.62 5.8Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgPlayOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgPlayOutline;
